import { render, staticRenderFns } from "./FailedTemplate.vue?vue&type=template&id=0cbb2822"
import script from "./FailedTemplate.vue?vue&type=script&lang=js"
export * from "./FailedTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports